import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ContactUsViewModel } from '../models';

@Injectable()
export class ContactUsService {

  constructor(private http: HttpClient) { }

  post(model: ContactUsViewModel) {
    return this.http.post('/contactus', model);
  }

  contactUs(model: ContactUsViewModel) {
    return this.http.post('/contactus/email', model);
  }
}